import React, { Component } from 'react';
import Multiselect from 'react-widgets/lib/Multiselect';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  name: PropTypes.string,
  userScope: PropTypes.array.isRequired,
  value: PropTypes.array,
});
/* eslint-enable react/no-unused-prop-types */

export class UserPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
  }


  handleChange(items, meta) {
    const { dataItem } = meta;
    if (!dataItem) {
      return;
    }

    this.props.onChange(items);
    /* NOTE: Closing the dropdown after selection for a better mobile experience
     * and to direct the user to type in employee's name instead of searching list */
    this.handleOnToggle(false);
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  render() {
    const { userScope, value } = this.props;
    const { open } = this.state;
    return (
      <Multiselect
        value={value}
        onChange={this.handleChange}
        data={userScope}
        open={open}
        onFocus={this.handleOnFocus}
        onToggle={this.handleOnToggle}
        onMouseDown={(e) => { e.preventDefault(); }}
        filter="contains"
        textField={(user) => { return user.fullname; }}
      />
    );
  }
}

UserPicker.propTypes = propTypes;

export default UserPicker;
